import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  indexAxis: 'y' as const,
  elements: {
    bar: {
      borderWidth: 1,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: 'right' as const,
      display: false,
    },
    datalabels: {
      display: false,
    },
    title: {
      display: true,
      text: 'Submissions per question',
      padding: 16,
      font: {
        size: 20,
      },
    },
  },
};

type CustomHorizontalChartProps = {
  narrativesData: any;
};

const CustomHorizontalChart: React.FC<CustomHorizontalChartProps> = ({
  narrativesData,
}) => {
  const chartData = (data: any) => {
    let total = [];
    if (data.length == 0) {
      return total;
    }
    data.forEach((resp: any) => {
      for (let i = 0; i < resp.length; i++) {
        total[i] = total[i] ? total[i] + 1 : 1;
      }
    });
    return total;
  };

  const customData = chartData(narrativesData);

  const labels = customData.map((_, idx) => `Responses for Q${idx + 1}`);
  const data = {
    labels,
    datasets: [
      {
        data: customData,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        barThickness: 50,
      },
    ],
  };

  return (
    <div
      style={{
        padding: '1.5rem 2rem',
        marginBottom: '1rem',
      }}
    >
      <Bar options={options} data={data} />
    </div>
  );
};

export default CustomHorizontalChart;
